export class StopStatusModel {
    id: number;
    name: string;

    constructor () {
        this.id = 0;
        this.name = '';
    }

    public static fromJson (json: any): StopStatusModel {
        const stopStatus = new StopStatusModel;
        Object.assign(stopStatus, {
            id: json.id,
            name: json.name
        });
        return stopStatus;
    }
}